import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'customerEmailFilter'
})

export class BulkInstoreSearch implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!args) {
      return value;
    }
    return value.filter((val) => {
      let rVal = (val.showroom.toLocaleLowerCase().includes(args)) || (val.region.toLocaleLowerCase().includes(args));
      return rVal;
    })

  }

}